import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const About = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Acerca de Jooru
        </Typography>
        <Typography variant="body1" paragraph>
          Jooru es una plataforma innovadora que conecta profesionales con clientes 
          de manera fácil, rápida y segura.
        </Typography>
        <Typography variant="body1">
          Nuestra misión es facilitar el acceso a servicios profesionales de calidad 
          en tu área local.
        </Typography>
      </Box>
    </Container>
  );
};

export default About;